import {
  chakra,
  Tag as ChakraTag,
  TagProps as ChakraTagProps,
  TagCloseButton,
  TagLabel,
  useColorModeValue,
} from '@cardboard-ui/react';
import React, { FC, MouseEventHandler, PropsWithChildren } from 'react';

interface TagProps extends ChakraTagProps {
  isActive?: boolean;
  onClick?: MouseEventHandler;

  onDelete?(): void;
}

export const Tag: FC<PropsWithChildren<TagProps>> = ({
  isActive,
  onClick,
  onDelete,
  children,
  ...props
}) => {
  const highLightColor = useColorModeValue('gray.100', 'gray.500');

  return (
    <ChakraTag
      colorScheme="blue"
      size="lg"
      backgroundColor={isActive ? highLightColor : ''}
      {...props}
    >
      <TagLabel
        cursor="pointer"
        _hover={{ textDecor: 'underline' }}
        onClick={onClick}
      >
        <chakra.span opacity={0.4} fontWeight="bold">
          #
        </chakra.span>
        {children}
      </TagLabel>
      {onDelete && <TagCloseButton onClick={onDelete} />}
    </ChakraTag>
  );
};
